export default {
  inject: ['$section'],
  mounted() {
    this.$section.bus.on('mouseenter', this.expand);
    this.$section.bus.on('mouseleave', this.collapse);
  },
  beforeDestroy() {
    this.$section.bus.off('mouseleave', this.collapse);
    this.$section.bus.off('mouseenter', this.expand);
  },
  methods: {
    expand(vTile) {
      const tile = vTile.$el;
      const tileRect = tile.getBoundingClientRect();
      const parentRect = this.$section.$el.querySelector('.js-section-container').getBoundingClientRect();
      const isFirst = Math.round(tileRect.left) <= Math.round(parentRect.left);
      const isLast = Math.round(tileRect.right) >= Math.round(parentRect.right);

      clearTimeout(this.collapseTimeout);
      this.delayedExpand(vTile, isFirst, isLast);
    },
    delayedExpand(vTile, isFirst, isLast) {
      const tile = vTile.$el;

      clearTimeout(this.expandTimeout);

      this.expandTimeout = setTimeout(() => {
        this.$el.classList.add('is-active');

        let multipliers;

        if (this.vTile) {
          // Collapse previously expanded tile
          this.$section.bus.emit('collapse', this.vTile);
        }

        this.$section.bus.emit('expand', vTile);

        if (isFirst) {
          multipliers = [0, 0.5, 1];
        } else if (isLast) {
          multipliers = [-1, -0.5, 0];
        } else {
          multipliers = [-0.5, 0, 0.5];
        }

        this.shiftPrevious(tile, multipliers[0] * tile.offsetWidth);
        this.shiftCurrent(tile, multipliers[1] * tile.offsetWidth, this.scale);
        this.shiftNext(tile, multipliers[2] * tile.offsetWidth);

        this.vTile = vTile;
        this.delay = 300;
      }, this.delay);
    },
    collapse() {
      clearTimeout(this.expandTimeout);
      clearTimeout(this.collapseTimeout);

      this.collapseTimeout = setTimeout(() => {
        this.delay = 1000;

        if (this.vTile) {
          const tile = this.vTile.$el;

          this.$section.bus.emit('collapse', this.vTile);

          this.shiftPrevious(tile);
          this.shiftCurrent(tile);
          this.shiftNext(tile);

          this.vTile = undefined;
        }

        this.$el.classList.remove('is-active');
      }, 300);
    },
    shiftCurrent(tile, offset = 0, scale = { x: 1, y: 1, z: 1 }) {
      tile.style.transform = this.buildStyleString(offset, scale);
    },
    shiftPrevious(tile, offset = 0) {
      while (tile.previousElementSibling) {
        tile = tile.previousElementSibling;
        tile.style.transform = this.buildStyleString(offset);
      }
    },
    shiftNext(tile, offset = 0) {
      while (tile.nextElementSibling) {
        tile = tile.nextElementSibling;
        tile.style.transform = this.buildStyleString(offset);
      }
    },
    buildStyleString(x = 0, scale = { x: 1, y: 1, z: 1 }) {
      return `translate3d(${x}px,0,0) scale3d(${scale.x}, ${scale.y}, ${scale.z})`;
    },
  },
};
